import styled from 'styled-components';
import Share from '@mlb/react-patterns/v4/components/Share/share';

export const ShareWrapper = styled.div`
    color: var(--gameday-primary-font-color);
    z-index: 1;

    &:hover {
        svg {
            fill: var(--gameday-primary-font-color);
            path {
                fill: var(--gameday-primary-font-color);
            }
        }
    }
    svg {
        fill: var(--gameday-primary-font-color);
        path {
            fill: var(--gameday-primary-font-color);
        }
        pointer-events: auto;
    }
`;

export const ShareOverride = styled(Share)`
    .share-button {
        z-index: 2;
        height: ${({ $size }) => $size === 'sm' ? '30px' : '20px'};
        top: ${({ $size }) => $size === 'sm' ? '0' : '5px'};
    }
`;
